import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import {BoxesModule} from "../../boxes/boxes.module";
import {MatIconModule} from "@angular/material/icon";
import {ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import { RecoveryPasswordComponent } from './recovery-password/recovery-password.component';
import { SignupComponent } from './signup/signup.component';
import {MatCardModule} from "@angular/material/card";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";
import {MatInputModule} from "@angular/material/input";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {WidgetModule} from "../../widget/widget.module";


@NgModule({
  declarations: [LoginComponent, RecoveryPasswordComponent, SignupComponent],
  exports: [
    LoginComponent
  ],
    imports: [
        CommonModule,
        AuthRoutingModule,
        MatCardModule,
        MatProgressSpinnerModule,
        BoxesModule,
        MatFormFieldModule,
        MatIconModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatInputModule,
        TranslateModule,
        MatCheckboxModule,
        WidgetModule
    ]
})
export class AuthModule { }
